import { ReactNode, useContext } from 'react';
import { IFormAction } from '../../@types/entityTypes';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { IStockTransfer } from '../../graphql/schema/p4types';

enum StockTransferAction {
  ProcessAll = 'STOCK_TRANSFER_PROCESS_ALL',
}

export const formActionsForPermissions: Array<{ actionReference: StockTransferAction }> = [
  {
    actionReference: StockTransferAction.ProcessAll,
  },
];

export const useStockTransferFormActions = (): [Array<IFormAction<StockTransferAction>>, ReactNode] => {
  const connectedForm = useContext(ConnectedFormContext);
  return [
    [
      {
        key: 'processAll',
        text: 'Process All',
        tooltip: 'Update all Stock Transfer lines to processed.',
        onClick: () => {
          const stockTransfer = connectedForm.values as IStockTransfer;
          stockTransfer.transferLines?.forEach((transferLine, rowIndex) => {
            connectedForm.change(`transferLines.${rowIndex}.processed`, true);
          });
        },
        actionReference: StockTransferAction.ProcessAll,
      },
    ],
    null,
  ];
};
